<template>
    <v-app class="white">
        <!-- 상단타이틀 -->
        <div class="top-bg">
             <!-- 배경 -->
            <img 
            src="@/assets/top_bg.png"
            class="img-top-bg"> 
            <!-- 타이틀 -->
            <div class="top-title-logo">
                <img 
                src="@/assets/top_title_img.png"
                class="img-title-logo"> 
            </div> 
            <!-- 뒤로가기 버튼 -->
            <div class="top-backkey"
             @click.passive="onClickBack()"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/backkey.png"
                class="img-backkey"> 
            </div>  
        </div> 
        <!-- 시세창 -->
        <div class="price-box">
            <img 
            src="@/assets/price_bg.png"
            class="img-price-box"> 
            <div class="txt-eth-price">{{this.mSymbol}} {{$t('market_price')}}</div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'krw'">{{this.mCoinPriceKRW}}</div>
            <div class="txt-eth-value" v-show="this.$langUtil.getCurrency() == 'usd'">{{this.mCoinPriceUSD}}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'krw'">{{ $t('krw_won') }}</div>
            <div class="txt-eth-unit" v-show="this.$langUtil.getCurrency() == 'usd'">{{ $t('usd') }}</div>
        </div> 
        <!-- 이더로고 -->
        <div class="ether-logo-position">
            <img 
            :src="this.mIconUrl"
            class="img-ether-logo"> 
        </div>    
        <!-- 이더량 -->
        <div class="ether-amount">{{$satoshiUtil.satoshiToMCH(this.mBalance)}} {{this.mSymbol}}</div>

        <div :class="mMiddleCss">
            <!-- 받기 -->
            <div class="btn-receive"
            @click.passive="onClickReceive()"
            v-ripple="{ center: true, class: `teal--text`  }"
            >
                <img 
                src="@/assets/img_receive_icon.png"
                class="img-center-icon"> 
                <div class="txt-receive-send">{{ $t('receive') }}</div>
            </div>
            <!-- 보내기 -->
            <div class="btn-send"
            @click.passive="onClickSend()"
            v-ripple="{ center: true, class: `teal--text`  }"
            >
                <img 
                src="@/assets/img_send_icon.png"
                class="img-center-icon"> 
                <div class="txt-receive-send">{{ $t('send') }}</div>            
            </div>        
            <!-- MCH전환 -->  
            <div class="btn-convert"
            v-show="this.mCoinType != '3'"
            @click.passive="onClickConvert()"
            v-ripple="{ center: true, class: `teal--text`  }"
            >
                <img 
                src="@/assets/img_convert_icon.png"
                class="img-center-icon"> 
            </div>
            <div 
            v-show="this.mCoinType != '3'"
            class="txt-mch-convert">{{ $t('convert_mch') }}</div>  
        </div>   
 
        <!-- 라인 -->
        <div class="bottom-line-history"></div>
        <!-- 거래내역 -->
        <div class="txt-history">{{ $t('history_list') }}</div>
        <!-- 거래내역 기간 -->
        <div 
        @click.passive="onClickPeriod()"
        v-ripple="{ center: true, class: `teal--text`  }"
        class="input-period">
            <img 
            src="@/assets/history_period.png"
            class="img-period">  
            <div class="txt-period">{{ $t('period_search') }}</div>    
            <div class="txt-period-01">{{this.mStartDate}} ~ {{this.mEndDate}}</div> 
            <img 
            src="@/assets/arrow_down.png"
            class="img-arrow-down">                
        </div>
        <!-- 라인 -->
        <div class="bottom-line"></div>
        <!-- 라인 -->
        <div class="bottom-blue01-line"></div>   
        <!-- 라인 -->
        <div class="bottom-blue02-line"></div>   
             
        <!-- 거래 히스토리 -->
        <div class=history-list>
            <v-list two-line="">
                <template v-for="(item, index) in this.mHistoryList">
                    <div 
                    v-bind:key="index"
                    class="wallet-list-item"
                    @click.passive="onClickList(item)"
                    v-ripple="{ center: true, class: `teal--text` }">
                        <!-- 받기 -->
                        <img 
                        v-show="item.tx_type == 'RE'"
                        src="@/assets/history_receive_icon.png"
                        class="history-icon">
                        <!-- 전환 -->
                        <img
                        v-show="item.tx_type == 'CM'" 
                        src="@/assets/history_convert_icon.png"
                        class="history-icon">  
                        <!-- 보내기 -->
                        <img 
                        v-show="item.tx_type == 'SE'"
                        src="@/assets/history_send_icon.png"
                        class="history-icon">    
                        <div 
                         v-show="item.tx_type == 'RE'"
                        class="wallet-txt-receive">{{ $t('receive') }}</div>
                        <div 
                        v-show="item.tx_type == 'CM'"
                        class="wallet-txt-receive">{{ $t('convert_menu') }}</div>
                        <div 
                        v-show="item.tx_type == 'CM'"
                        class="walet-list-txt-convert">{{ getConvertType(item) }} </div>
                        <div 
                        v-show="item.tx_type == 'SE'"
                        class="wallet-txt-receive">{{ $t('send') }}</div>

                        <div class="wallet-txt-amount">{{ $satoshiUtil.satoshiToMCH(item.amount) }} {{mSymbol}}</div>
                        <div class="history-txt-date">{{item.date}}</div>
                        <div class="history-txt-amount">{{ $satoshiUtil.satoshiToMCH(item.total_balance) }} {{mSymbol}}</div>
                        <div class="history-txt-balance">{{ $t('balance') }}</div>
                        <div class="history-txt-label"></div>
                        <div class="history-item-line"></div>
                    </div>
                </template>
            </v-list>
        </div>
        <!-- 로딩바 -->
        <div class="loading-bar-postion" v-show="mShowLoading">
            <v-progress-circular
            indeterminate
            color="red"
            ></v-progress-circular>
        </div>
        <!-- 검색창 팝업 -->
        <v-dialog
        v-model="mShowPeriod"
        max-width="290">
            <div class="poup-period-bg">
                <img 
                src="@/assets/period_bg.png"
                class="img-period-bg">  
                <div class="popup-txt-perid">{{ $t('period_search') }}</div>
                <div class="popup-period-date">{{this.mStartDate}} ~ {{this.mEndDate}}</div>
                <img 
                src="@/assets/img_arrow_up.png"
                class="img-arrow-up">  
                <div 
                @click.passive="onClickClosePeriod()"
                v-ripple="{ center: true, class: `teal--text`  }"
                class="popup-btn-close"></div>
                <div 
                @click.passive="onClickPickerDateStart()"
                v-ripple="{ center: true, class: `teal--text`  }"                
                class="popup-start-date">
                    <div class="txt-period-center">{{this.mStartDate}}</div> 
                </div>
                <div 
                @click.passive="onClickPickerDateEnd()"
                v-ripple="{ center: true, class: `teal--text`  }"  
                class="popup-end-date">
                    <div class="txt-period-center">{{this.mEndDate}}</div>
                </div>
                <div 
                @click.passive="onClickOneDay()"
                v-ripple="{ center: true, class: `teal--text`  }"   
                class="popup-period-00">
                    <img 
                    :src="mImgPeriod00"
                    class="btn-period-bg">  
                    <div class="popup-txt-period">{{ $t('today') }}</div>
                </div>
                <div 
                @click.passive="onClick1week()"
                v-ripple="{ center: true, class: `teal--text`  }"                
                class="popup-period-01">
                    <img 
                    :src="mImgPeriod01"
                    class="btn-period-bg">  
                    <div class="popup-txt-period">{{ $t('one_week') }}</div>
                </div>
                <div 
                @click.passive="onClick1month()"
                v-ripple="{ center: true, class: `teal--text`  }"                
                class="popup-period-02">
                    <img 
                    :src="mImgPeriod02"
                    class="btn-period-bg">   
                    <div class="popup-txt-period">{{ $t('one_month') }}</div>                  
                </div>
                <div 
                @click.passive="onClick3month()"
                v-ripple="{ center: true, class: `teal--text`  }"                
                class="popup-period-03">
                    <img 
                    :src="mImgPeriod03"
                    class="btn-period-bg"> 
                    <div class="popup-txt-period">{{ $t('three_month') }}</div>
                </div>
                <div 
                @click.passive="onClickYear()"
                v-ripple="{ center: true, class: `teal--text`  }"                
                class="popup-period-04">
                    <img 
                    :src="mImgPeriod04"
                    class="btn-period-bg"> 
                    <div class="popup-txt-period">{{ $t('one_year') }}</div>
                </div>
                <div 
                @click.passive="onClickSearch()"
                v-ripple="{ center: true, class: `teal--text`  }"                
                class="btn-search">
                    <img 
                    src="@/assets/btn_search.png"
                    class="img-search-bg"> 
                    <div class="popup-txt-search">{{ $t('search') }}</div>
                </div>
                <div 
                @click.passive="onSelAll()"
                v-ripple="{ center: true, class: `teal--text`  }" 
                class="btn-select-all">
                    <img 
                        :src="mPeriodSelAll"
                        class="btn-period-sel"> 
                    <div class="txt-center">{{ $t('all') }}</div>
                </div>
                <div 
                @click.passive="onSelSend()"
                v-ripple="{ center: true, class: `teal--text`  }" 
                class="btn-select-receive">
                    <img 
                        :src="mPeriodSelSend"
                        class="btn-period-sel"> 
                    <div class="txt-center">{{ $t('send') }}</div>
                </div>
                <div 
                @click.passive="onSelReceive()"
                v-ripple="{ center: true, class: `teal--text`  }" 
                class="btn-select-send">
                    <img 
                        :src="mPeriodSelReceive"
                        class="btn-period-sel">           
                    <div class="txt-center">{{ $t('receive') }}</div>
                </div>
            </div>
        </v-dialog>
        <!-- 달력 -->
        <v-dialog
        v-model="mShowPickerStart"
        max-width="290">
            <v-date-picker v-model="mStartDate"></v-date-picker>
        </v-dialog>
        <v-dialog
        v-model="mShowPickerEnd"
        max-width="290">
            <v-date-picker v-model="mEndDate"></v-date-picker>
        </v-dialog>
        <!-- 상세보기 -->
        <div class="text-center">
            <v-dialog
            v-model="mDialogDetail"
            width="500"
            >
            <div class="detail-popup-bg">
                <div class="detail-popup-fee"> {{ $t('fee') }}</div>
                <div class="detail-popup-fee-bg"> 
                    <img 
                    src="@/assets/detail_popup_list_bg.png"
                    class="img-detail-popup-item">
                    <div class="detail-popup-fee-val">{{this.mDetailFee}}</div>
                </div>
                <div class="detail-popup-address">{{ $t('address_wallet_02') }}</div>
                <div class="detail-popup-address-bg"> 
                    <img 
                    src="@/assets/detail_popup_list_bg.png"
                    class="img-detail-popup-item">
                    <div class="detail-popup-address-val">{{this.mDetailAddress}}</div>
                </div>
                <div class="detail-popup-txid">TXID</div>
                <div class="detail-popup-txid-bg"> 
                    <img 
                    src="@/assets/detail_popup_list_bg.png"
                    class="img-detail-popup-item">
                    <div 
                    @click.passive="onCilckTxid()"
                    v-ripple="{ center: true, class: `teal--text`  }" 
                    class="detail-popup-txid-val">{{this.mDetailTxid}}</div>
                </div>
            </div>
            </v-dialog>
        </div>
    </v-app>
</template>
<script>
import axios from 'axios';
export default {
  created() {
    let payload = this.$route.query.payload;
    let decrypto = this.$cryptoUtil.decrptoMessage(payload);
    let json = JSON.parse(JSON.parse(decrypto));
    this.mMno = json.mno;
    this.mCoinType = json.coin_type;
    this.mSymbol = json.symbol;
    this.mSymbol = this.mSymbol.toUpperCase();
    this.mIconUrl = json.icon_url;
    this.mAddress = json.address;
    this.mCoinName = json.coin_name;
    this.mCoinNameEn = json.coin_name_en;
    this.mSendFee = json.send_fee;
    this.mLoginKey = json.login_key;
    this.calDateOneMonth(); // 오늘 부터 한달 전 구함 
    this.marketPrice();
    if(this.mCoinType == "3") {
        this.mMiddleCss = "btn-middle-position-00";
    } else {
        this.mMiddleCss = "btn-middle-position-01";
    }
    this.onClickSel(1);
    this.setSearchType(1);
  },
  data: () => ({
    mMno : "",
    mPasswd : "",
    mCoinType : "",
    mSymbol : "",
    mCoinPriceKRW : "",
    mCoinPriceUSD : "",
    mShowLoading : false,
    mBalance : "",
    mAddress : "",
    mCoinName : "",
    mCoinNameEn : "",
    mMiddleCss : "btn-middle-position-00",
    mSendFee : "",
    mShowPeriod : false,
    mImgPeriod00 : require('@/assets/btn-period-enable.png'),
    mImgPeriod01 : require('@/assets/btn-period-enable.png'),
    mImgPeriod02 : require('@/assets/btn-period-enable.png'),
    mImgPeriod03 : require('@/assets/btn-period-enable.png'),
    mImgPeriod04 : require('@/assets/btn-period-enable.png'),
    picker : new Date().toISOString().substr(0, 10),
    mShowPickerStart : false,
    mShowPickerEnd : false,
    mStartDate : "",
    mEndDate : "",
    mPeriodSelAll : require('@/assets/popup_period_sel.png'),  
    mPeriodSelSend : require('@/assets/popup_period_unsel.png'),  
    mPeriodSelReceive : require('@/assets/popup_period_unsel.png'), 
    mPeriodSearchType : 1, 
    mHistoryList : [],
    mDialogDetail : false,
    mDetailFee : "",
    mDetailAddress : "",
    mDetailTxid : "",
    mLoginKey : "",
  }),
  methods : {
    formatDate : function(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    },
    calDateToday : function() {
        this.mStartDate = this.formatDate(new Date());
        this.mEndDate = this.formatDate(new Date());
    },
    calDateOneWeek : function() {
        this.mEndDate = this.formatDate(new Date());
        var d = new Date()
        var dayOfMonth = d.getDate()
        d.setDate(dayOfMonth - 7)
        this.mStartDate = this.formatDate(d);
    },
    calDateOneMonth : function() {
        this.mEndDate = this.formatDate(new Date());
        var d = new Date()
        var monthOfYear = d.getMonth()
        d.setMonth(monthOfYear - 1)
        this.mStartDate = this.formatDate(d);
    },
    calDateThreeMonth : function() {
        this.mEndDate = this.formatDate(new Date());
        var d = new Date()
        var monthOfYear = d.getMonth()
        d.setMonth(monthOfYear - 3)
        this.mStartDate = this.formatDate(d);
    },
    calDateOneYear : function() {
        this.mEndDate = this.formatDate(new Date());
        var d = new Date()
        var monthOfYear = d.getMonth()
        d.setMonth(monthOfYear - 12)
        this.mStartDate = this.formatDate(d);
    },
    onClickSel : function(num) {
        if(num == 1) {
            this.mImgPeriod00 = require('@/assets/btn-period-enable.png');
            this.mImgPeriod01 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod02 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod03 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod04 = require('@/assets/btn-period-disable.png');
        } else if(num == 2) {
            this.mImgPeriod00 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod01 = require('@/assets/btn-period-enable.png');
            this.mImgPeriod02 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod03 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod04 = require('@/assets/btn-period-disable.png');
        } else if(num == 3) {
            this.mImgPeriod00 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod01 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod02 = require('@/assets/btn-period-enable.png');
            this.mImgPeriod03 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod04 = require('@/assets/btn-period-disable.png');
        } else if(num == 4) {
            this.mImgPeriod00 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod01 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod02 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod03 = require('@/assets/btn-period-enable.png');
            this.mImgPeriod04 = require('@/assets/btn-period-disable.png');
        } else if(num == 5) {
            this.mImgPeriod00 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod01 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod02 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod03 = require('@/assets/btn-period-disable.png');
            this.mImgPeriod04 = require('@/assets/btn-period-enable.png');
        } 
    },
    onClickBack : function() {
        this.$router.go(-1);
    },
    onClickReceive : function() {
        let payload = {};
        payload.mno = this.mMno;
        payload.coin_type = this.mCoinType;
        payload.symbol = this.mSymbol;
        payload.icon_url = this.mIconUrl;
        payload.address = this.mAddress;
        let payloadJson = JSON.stringify(payload);
        let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
        this.$router.push( { path : 'receive_main', query: { payload : crypto } } );
    }, 
    onClickPickerDateStart : function() {
        this.mShowPickerStart = true;
    },
    onClickPickerDateEnd : function() {
        this.mShowPickerEnd = true;
    },
    onClickSend : function() {
        let payload = {};
        payload.mno = this.mMno;
        payload.passwd = this.mPasswd;
        payload.coin_type = this.mCoinType;
        payload.symbol = this.mSymbol;
        payload.icon_url =this.mIconUrl;
        payload.address = this.mAddress;
        payload.send_fee = this.mSendFee;
        payload.login_key = this.mLoginKey;
        let payloadJson = JSON.stringify(payload);
        let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
        this.$router.push( { path : 'send_main', query: { payload : crypto } } );
    },  
    onClickConvert : function() {
        let payload = {};
        payload.mno = this.mMno;
        payload.coin_type =  this.mCoinType;
        payload.symbol = this.mSymbol;
        payload.icon_url = this.mIconUrl;
        payload.address = this.mAddress;
        payload.coin_name = this.mCoinName;
        payload.coin_name_en = this.mCoinNameEn;
        payload.login_key = this.mLoginKey;
        let payloadJson = JSON.stringify(payload);
        let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
        this.$router.push( { path : 'convert_main', query: { payload : crypto} } );
    }, 
    marketPrice : function() {
        let payload = {};
        payload.cmd = "get-market-price";
        payload.mno = this.mMno;
        payload.coin_type = this.mCoinType;
        
        this.mShowLoading = true;
        axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
        .then(response => {
            console.log(response);
            this.mShowLoading = false;
            let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K")); 
            if(serverResponse.result == "1") { // 성공
                this.mCoinPriceKRW = this.$currencyUtil.numberWithCommas(serverResponse.coin_price);
                this.mCoinPriceUSD = this.$currencyUtil.numberWithCommas(serverResponse.coin_price_usd);
            } else if(serverResponse.result == "2") { // 기존사용자존재
            
            } else if(serverResponse.result == "0") { // 오류
                
            }
            this.getBalance();
        })
        .catch( ()=>{} );
    },
    getBalance : function() {
        let payload = {};
        payload.cmd = "get-balance";
        payload.mno = this.mMno;
        payload.coin_type = this.mCoinType;
        
        this.mShowLoading = true;
        axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
        .then(response => {
            console.log(response);
            let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));  
            this.mShowLoading = false;
            if(serverResponse.result == "1") { // 성공
                this.mBalance = serverResponse.balance;
            } else if(serverResponse.result == "2") { // 기존사용자존재
            
            } else if(serverResponse.result == "0") { // 오류
                
            }
            this.transactionList();
        })
        .catch( ()=>{} );
    },
    transactionList : function() {
        this.mHistoryList = [];
        let payload = {};
        payload.cmd = "transaction-list";
        payload.mno = this.mMno;
        payload.coin_type = this.mCoinType;
        payload.mode =  String(this.mPeriodSearchType);
        payload.start = this.mStartDate;
        payload.end = this.mEndDate;
        console.log("" + JSON.stringify(payload) )
        this.mShowLoading = true;
        axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
        .then(response => {
            let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K")); 
            this.mShowLoading = false;
            for( var i = 0 ; i < serverResponse.list.length ; i++ ) {
                this.mHistoryList.push(serverResponse.list[i]);
            }
        })
        .catch( ()=>{} );
    },
    onClickPeriod : function() {
        this.mShowPeriod = true;
    },
    onClickClosePeriod : function() {
        this.mShowPeriod = false;
    },
    onClickOneDay : function() {
        console.log("onClickOneDay")
        this.onClickSel(1);
        this.calDateToday();
    },
    onClick1week : function() {
        console.log("onClick1week")
        this.onClickSel(2);
        this.calDateOneWeek();
    },
    onClick1month : function() {
        console.log("onClick1month")
        this.onClickSel(3);
        this.calDateOneMonth();
    },
    onClick3month : function() {
        console.log("onClick3month")
        this.onClickSel(4);
        this.calDateThreeMonth();
    },
    onClickYear : function() {
        console.log("onClickYear")
        this.onClickSel(5);
        this.calDateOneYear();
    },
    onClickSearch : function() {
        this.mShowPeriod = false;
        this.transactionList();
    },
    onSelAll : function() {
        this.setSearchType(1);
    },
    onSelSend : function() {
        this.setSearchType(2);
    },
    onSelReceive : function() {
        this.setSearchType(3);
    },
    onClickHistory : function(item) {

    },
    onClickList : function(item) {
        console.log(item)
        this.mDialogDetail = true;
        this.mDetailFee = this.$currencyUtil.numberWithCommas(  this.$satoshiUtil.satoshiToMCH(item.fee) ) + " " + this.mSymbol;
        this.mDetailAddress = item.address;
        this.mDetailTxid = item.tx_id;
    },
    setSearchType : function(no) {
        this.mPeriodSearchType = no;
        if(no == 1) {
            this.mPeriodSelAll = require('@/assets/popup_period_sel.png');
            this.mPeriodSelSend = require('@/assets/popup_period_unsel.png');
            this.mPeriodSelReceive = require('@/assets/popup_period_unsel.png'); 
        } else if(no == 2) {
            this.mPeriodSelAll = require('@/assets/popup_period_unsel.png');
            this.mPeriodSelSend = require('@/assets/popup_period_sel.png');
            this.mPeriodSelReceive = require('@/assets/popup_period_unsel.png'); 
        } else if(no == 3) {
            this.mPeriodSelAll = require('@/assets/popup_period_unsel.png');
            this.mPeriodSelSend = require('@/assets/popup_period_unsel.png');
            this.mPeriodSelReceive = require('@/assets/popup_period_sel.png'); 
        } 

    },
    onCilckTxid : function() {
        console.log(" " + this.mCoinType)
        if(this.mCoinType == 2) {
            location.replace("https://etherscan.io/tx/" + this.mDetailTxid);
        } else if(this.mCoinType == 3) {
            location.replace("http://explorer.meconcash.io/tx/" + this.mDetailTxid);
        }
        
    },
    getConvertType(item) {
        console.log("getConvertType" + this.mCoinType + JSON.stringify(item) )
        if(this.mCoinType == '3') { // 미콘캐시
            var txid = item.tx_id;
            var str = txid.split('-');
            if(str[2] == '2') {
                return this.$t('from_ether')
            }
            return;
        }
        return this.$t('mch_to')
    }
  }
}
</script>
<style scoped>
  * {
      margin: 0;
      font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
      font-weight: 300;
      padding: 0;
  }
  html, body {
    height: 100vh;
    width: 100vw;
  }
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
    height: 13.24vw;
    width: 100vw;
    background-color: white;
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-backkey {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-backkey {
    position: absolute;
    top: 4.07vw;
    left: 5.64vw;
    height: 5.277vw;
    width: 2.77vw;
}
.top-title-logo {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: 5.925926vw;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
}
.img-title-logo {
    height: 5.925926vw;
    width: auto;
}
.price-box {
    position: absolute;
    top: 15.37vw; 
    left: 5.6vw;
    height: 8.148vw;
    width: 88.9vw;     
}
.img-price-box {
    height: 8.148vw;
    width: 88.9vw; 
}
.txt-eth-price {
    position: absolute;
    top: 50%; 
    left: 5.5vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-value {
    position: absolute;
    top: 50%; 
    right: 14vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: right;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.txt-eth-unit {
    position: absolute;
    top: 50%; 
    right: 6.2vw;
    font-size: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);     
}
.ether-logo-position {
    position: absolute;
    top: 28.148vw; 
    left: 50%;    
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%); 
}
.img-ether-logo {
    width: auto;
    height: 8.333vw;     
}
.ether-amount {
    position: absolute;
    top: 37.96296vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    font-family: NanumBarunGothicOTF;
    font-size: 5.092593vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #345993;        
}
.img-center-icon {
    position: absolute;
    top: 50%; 
    left: 50%;
    height: 4.62963vw;
    width: auto;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);       
}
.txt-receive-send {
    position: absolute;
    top: 110%; 
    left: 0px;
    width: 100%;
    text-align: center;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #757c7e;   
}
.bottom-line {
    position: absolute;
    top: 69.62963vw; 
    left: 0vw;    
    width: 100vw;
    height: 5px;
    background-color: #f3f6fb;  
}
.bottom-blue01-line {
    position: absolute;
    top: 69.7vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.bottom-blue02-line {
    position: absolute;
    top: 70.7vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: #d0dcee;     
}
.txt-history {
    position: absolute;
    top: 74.81481vw; 
    left: 5.8vw;  
    width: 50vw;
    height: 3.7vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #040000;
}
.img-period {
    width: 100%;
    height: 7.777vw;
}
.input-period {
    position: absolute;
    top: 81.85185vw; 
    left: 5.6vw; 
    right: 5.6vw;
    width: auto;
    height: 7.777vw;
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
.btn-middle-position-00 {
    position: absolute;
    top: 47.7777vw; 
    left: 34vw; 
    width: 70vw;
    height: 20vw;
    display:block;
    overflow: hidden;
}
.btn-middle-position-01 {
    position: absolute;
    top: 47.7777vw; 
    left: 25vw; 
    width: 70vw;
    height: 20vw;
    display:block;
    overflow: hidden;
}
.btn-receive {
    position: absolute;
    top: 0vw; 
    left: 0vw;   
    width: 11.85vw;
    height: 11.85vw; 
    background-color: #345993;
    border-radius: 50%;
    display:block;
}
.btn-send {
    position: absolute;
    top: 0vw; 
    left: 19vw;   
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
    display:block;
}
.btn-convert {
    position: absolute;
    top: 0vw; 
    left: 38vw;  
    width: 11.85vw;
    height: 11.85vw;   
    background-color: #345993;
    border-radius: 50%;
}
.txt-mch-convert {
    position: absolute;
    top: 12.5vw; 
    left: 29vw;
    width: 30vw;  
    text-align: center;
    font-family: NanumBarunGothicOTF;
    font-size: 2.7vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #757c7e;    
}
.txt-period {
    position: absolute;
    top: 50%; 
    left: 5.3%;  
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;         
}
.txt-period-01 {
    position: absolute;
    top: 50%; 
    left: 25%;
    width: 50vw;  
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;         
}
.img-arrow-down {
    position: absolute;
    top: 30%; 
    right: 5%;
    height: 1.8vw;
    width: 2vw;   
}
.img-period-bg {
    position: absolute;
    top: 0vw; 
    left: 0vw;
    width: 88.9vw;
    height: 50.55vw;   
}
.popup-txt-perid {
    position: absolute;
    top: 3vw;  
    left: 4.62963vw;
    opacity: 0.8;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;    
}
.popup-period-date {
    position: absolute;
    top: 3vw;  
    left: 20vw;
    width: 63vw;
    opacity: 0.8;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;      
}
.poup-period-bg {
    position: absolute;
    top: 51vw; 
    left: 6vw;
    width: 88.9vw;
    height: 50.55vw;   
}
.img-arrow-up {
    position: absolute;
    top: 3vw; 
    right: 5.5vw;
    height: 1.8vw;
    width: 2vw;  
}
.popup-btn-close {
    position: absolute;
    top: 0vw; 
    left: 0vw;
    height: 10vw;
    width: 100%;  
}
.popup-start-date {
    position: absolute;
    top: 12vw; 
    left: 5.5vw;
    height: 8vw;
    width: 39%;
    text-align: center; 
    opacity: 0.8;
    font-family: NanumBarunGothicOTF;
    font-size: 3.703vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;  
}
.txt-period-center {
    position: absolute;
    top: 2vw; 
    left: 0vw;
    width: 100%;
    text-align: center;
}
.popup-end-date {
    position: absolute;
    top: 12vw; 
    right: 5.5vw;
    height: 8vw;
    width: 39%;
    text-align: center; 
    opacity: 0.8;
    font-family: NanumBarunGothicOTF;
    font-size: 3.703vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;     
}
.popup-period-00 {
    position: absolute;
    top: 21.666vw; 
    left: 4.62963vw;
    height: 6.481481vw;
    width: 15.18519vw; 
}
.popup-period-01 {
    position: absolute;
    top: 21.666vw; 
    left: 20.3vw;
    height: 6.481481vw;
    width: 15.18519vw; 
}
.popup-period-02 {
    position: absolute;
    top: 21.666vw; 
    left: 36vw;
    height: 6.481481vw;
    width: 15.18519vw; 
}
.popup-period-03 {
    position: absolute;
    top: 21.666vw; 
    left: 52vw;
    height: 6.481481vw;
    width: 15.18519vw; 
}
.popup-period-04 {
    position: absolute;
    top: 21.666vw; 
    left: 67.9vw;
    height: 6.481481vw;
    width: 15.18519vw; 
}
.btn-period-bg {
    height: 6.481481vw;
    width: 15.18519vw; 
}
.popup-txt-period {
    position: absolute;
    top: 50%; 
    left: 0%;
    width: 100%;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;    
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);    
}
.btn-search {
    position: absolute;
    top: 40vw; 
    left: 1vw;
    height: 9.62963vw;
    width: 87vw;     
}
.img-search-bg {
    height: 9.62963vw;
    width: 87vw; 
}
.popup-txt-search {
    position: absolute;
    top: 50%; 
    left: 50%;
    font-family: NanumBarunGothicOTF;
    font-size: 3.703704vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);  
}
.btn-select-all {
    position: absolute;
    top: 29vw; 
    left: 19vw;
    height: 9.62963vw;
    width: 15vw;
}
.btn-select-receive {
    position: absolute;
    top: 29vw; 
    left: 37vw;
    height: 9.62963vw;
    width: 15vw;
}
.btn-select-send {
    position: absolute;
    top: 29vw; 
    left: 55vw;
    height: 9.62963vw;
    width: 15vw;
}
.txt-center {
    position: absolute;
    top: 50%; 
    left: 3.7vw;
    opacity: 0.8;
    font-family: NanumBarunGothicOTF;
    font-size: 3.703704vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);      
}
.btn-period-sel {
    position: absolute;
    top: 3vw; 
    left: 0vw;
    height: 3vw;
    width: auto;
}
.history-list {
    position: absolute;
    top: 94vw; 
    left: 0vw;
    width: 100vw;
    height: auto;
    bottom: 3vw;
    overflow: scroll;
}
.bottom-line-history {
    position: absolute;
    top: 93vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: lightgray;      
}
.history-item-panel {
    position: relative;
    top: 0vw; 
    left: 5vw;;
    height: 50vw;
    width: 90vw;
}
.wallet-list-item {
    position: relative;
    margin-left: 0vw;
    margin-right: 0vw;
    margin-top: 0vw;
    height: 19.35185vw;
    width: auto;
}
.history-icon {
    position: absolute;
    top: 2vw; 
    left: 5.55vw;;    
    height: 5.5vw;
    width: 5.5vw;
}
.wallet-txt-receive {
    position: absolute;
    top: 7.962963vw; 
    left: 5.55vw;;  
    font-family: NanumBarunGothicOTF;
    font-size: 1.851852vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #399ed9;      
}
.walet-list-txt-convert {
    position: absolute;
    top: 13.5vw; 
    right: 5.55vw;;  
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;     
}
.wallet-txt-amount {
    position: absolute;
    top: 2vw; 
    left: 13vw;
    text-align: left;  
    width: 50.81481vw;
    height: 5.185185vw;
    font-family: NanumBarunGothicOTF;
    font-size: 4.62963vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    color: #399ed9;
}
.history-txt-date {
    position: absolute;
    top: 2vw; 
    right: 5.5vw;      
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;
}
.history-txt-amount {
    position: absolute;
    top: 8.2vw; 
    right: 5.5vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;    
}
.history-txt-balance {
    position: absolute;
    top: 8.2vw; 
    right: 38vw;         
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;    
}
.history-txt-label {
    position: absolute;
    top: 12.4vw; 
    right: 5.5vw;       
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;    
}
.history-item-line {
    position: absolute;
    bottom: 0vw; 
    right: 5.5vw;
    left: 5.5vw;  
    height: 1px;
    width: auto;
    background-color: #e5e5e5;    
}
::-webkit-scrollbar {
    display:none;
} 
.detail-popup-bg {
    position: absolute;
    top: 50%;   
    left : 10vw;
    height: 37vw;
    width: 80vw;
    background-color: white;  
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);      
}
.detail-popup-fee {
    position: absolute;
    top: 7vw;   
    left : 5vw;
    height: auto;
    width: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;    
}
.detail-popup-address {
    position: absolute;
    top: 17vw;   
    left : 5vw;
    height: auto;
    width: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;      
}
.detail-popup-txid {
    position: absolute;
    top: 27vw;   
    left : 5vw;
    height: auto;
    width: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000;      
}
.detail-popup-fee-bg {
    position: absolute;
    top: 5vw;   
    left : 20vw;
    height: 8.14vw;
    width: 55vw;    
}
.detail-popup-address-bg {
    position: absolute;
    top: 15vw;   
    left : 20vw;
    height: 8.14vw;
    width: 55vw;    
}
.detail-popup-txid-bg {
    position: absolute;
    top: 25vw;   
    left : 20vw;
    height: 8.14vw;
    width: 55vw;    
}
.img-detail-popup-item {
    height: 8.14vw;
    width: 55vw;    
}
.detail-popup-fee-val {
    position: absolute;
    top: 50%;   
    right: 2vw;
    height: auto;
    width: auto;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #040000; 
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);       
}
.detail-popup-address-val {
    position: absolute;
    top: 50%;   
    right: 2vw;
    height: 7vw;
    width: 50vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.0;
    letter-spacing: normal;
    text-align: left;
    color: #040000; 
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%);   
    display: inline-block; 
    overflow: hidden; 
    text-overflow: ellipsis; /* 여러 줄 자르기 추가 스타일 */ 
    white-space: normal;  
    word-wrap: break-word;      
}
.detail-popup-txid-val {
    position: absolute;
    top: 50%;   
    right: 2vw;
    height: 7vw;
    width: 50vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.0;
    letter-spacing: normal;
    text-align: center;
    color: #040000; 
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%); 
    display: inline-block; 
    overflow: hidden; 
    text-overflow: ellipsis; /* 여러 줄 자르기 추가 스타일 */ 
    white-space: normal;  
    word-wrap: break-word;    
}
</style>